import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";

export default function AdminTelecallers() {
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Delete this user?")) return;
    try { await api.delete(`/users/${id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="p-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <div className="mb-1 text-[11px] uppercase tracking-widest text-zinc-500">Team</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight text-black">Users & Telecallers</h1>
        </div>
        <button data-testid="add-user-btn" onClick={() => setShow(true)}
          className="inline-flex items-center gap-1.5 rounded-sm bg-black px-3 py-2 text-xs font-medium text-white hover:bg-zinc-800">
          <Plus className="h-3.5 w-3.5"/> Add User
        </button>
      </div>

      <div className="overflow-hidden rounded-sm border border-zinc-200 bg-white">
        <table className="w-full text-sm" data-testid="users-table">
          <thead className="bg-zinc-50 text-left text-[11px] uppercase tracking-wider text-zinc-500">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 w-16"></th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-t border-zinc-200 hover:bg-zinc-50">
                <td className="px-4 py-3 font-medium text-black">{u.name}</td>
                <td className="px-4 py-3 text-zinc-700">{u.email}</td>
                <td className="px-4 py-3"><span className={`rounded-sm px-2 py-0.5 text-[11px] font-medium ${u.role === "admin" ? "bg-black text-white" : "bg-zinc-100 text-zinc-700"}`}>{u.role}</span></td>
                <td className="px-4 py-3">{u.active ? <span className="text-emerald-700 text-xs">Active</span> : <span className="text-zinc-400 text-xs">Disabled</span>}</td>
                <td className="px-4 py-3 text-right">
                  <button data-testid={`delete-user-${u.id}`} onClick={() => del(u.id)} className="rounded-sm p-1 text-zinc-400 hover:bg-red-50 hover:text-red-600">
                    <Trash2 className="h-3.5 w-3.5"/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {show && <AddUserDialog onClose={() => setShow(false)} onSaved={() => { setShow(false); load(); }} />}
    </div>
  );
}

function AddUserDialog({ onClose, onSaved }) {
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "telecaller" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/users", form); toast.success("User created"); onSaved(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <form onSubmit={submit} className="w-full max-w-md rounded-sm border border-zinc-200 bg-white p-6">
        <div className="mb-4 flex items-start justify-between">
          <div>
            <div className="text-[11px] uppercase tracking-widest text-zinc-500">New</div>
            <h3 className="font-heading text-xl font-bold text-black">Create User</h3>
          </div>
          <button type="button" onClick={onClose} className="rounded-sm p-1 hover:bg-zinc-100"><X className="h-4 w-4"/></button>
        </div>
        {["name","email","password"].map((f) => (
          <div key={f} className="mb-3">
            <label className="mb-1 block text-[11px] uppercase tracking-wider text-zinc-500">{f}</label>
            <input data-testid={`add-user-${f}`} required type={f === "password" ? "password" : f === "email" ? "email" : "text"}
              value={form[f]} onChange={(e) => setForm({...form, [f]: e.target.value})}
              className="w-full rounded-sm border border-zinc-300 px-3 py-2 text-sm outline-none focus:border-black" />
          </div>
        ))}
        <div className="mb-4">
          <label className="mb-1 block text-[11px] uppercase tracking-wider text-zinc-500">Role</label>
          <select data-testid="add-user-role" value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}
            className="w-full rounded-sm border border-zinc-300 px-3 py-2 text-sm outline-none focus:border-black">
            <option value="telecaller">Telecaller</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <button data-testid="add-user-submit" type="submit" className="w-full rounded-sm bg-black px-4 py-2.5 text-sm font-semibold text-white hover:bg-zinc-800">Create</button>
      </form>
    </div>
  );
}
